import styled from '@emotion/styled'
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { WarrantyBaseData } from "api/delek"
import EmptyResults from "common/EmptyResults"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    /* box-shadow: 0 10px 20px 0 ${(p) => p.theme.colors.darkIndigo} inset;
    padding-top: 45px;
    margin-top: 45px; */
  `,
  Table: styled(Table)`
    .bold {
      font-weight: bold;
    }
  `,
  TableHead: styled(TableHead)`
    background-color: ${(p) => p.theme.colors.paleGrey};
  `,
  TableRow: styled(TableRow)`
    border-bottom: 2px solid rgba(135, 148, 161, 0.1);
  `,
  HeadCell: styled(TableCell)`
    font-size: 22px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
    text-align: center;
    padding: 25px 17px;
  `,
  Cell: styled(TableCell)`
    font-size: 18px;
    color: ${(p) => p.theme.colors.marine};
    text-align: center;
    padding: 25px 17px;
  `,
  Items: styled.div`
    padding: 0 17px;
    border-top: solid 1.5px ${(p) => p.theme.colors.silver};
    border-bottom: solid 1.5px ${(p) => p.theme.colors.silver};
  `,
  Item: {
    Container: styled(Typography)`
      padding: 17px 0;
      &:not(:last-of-type) {
        border-bottom: solid 1.5px ${(p) => p.theme.colors.silver};
      }
    `,
    Title: styled(Typography)`
      font-size: 16px;
      font-weight: bold;
      color: ${(p) => p.theme.colors.marine};
      margin-bottom: 10px;
    `,
    Value: styled(Typography)`
      font-size: 14px;
      color: ${(p) => p.theme.colors.marine};
      margin-bottom: 5px;
    `,
    Description: styled(Typography)`
      font-size: 12px;
      color: ${(p) => p.theme.colors.bluishGrey};
    `,
  },
}

type WarrantyExtensionsProps = {
  data: WarrantyBaseData[]
}

const WarrantyExtensionsTable = ({ data }: WarrantyExtensionsProps) => (
  <Styled.Wrapper>
    {data.length > 0 && (
      <>
        <Shared.Mobile>
          <Styled.Items>
            {data.map((item, i) => (
              <Styled.Item.Container key={i}>
                <Styled.Item.Title>{item.component}</Styled.Item.Title>
                <Styled.Item.Description>תיאור תופעה</Styled.Item.Description>
                <Styled.Item.Value>{item.phenomenonDesc}</Styled.Item.Value>
                <Styled.Item.Description>
                  משך הארכת אחריות
                </Styled.Item.Description>
                <Styled.Item.Value>{item.extensionDuration}</Styled.Item.Value>
              </Styled.Item.Container>
            ))}
          </Styled.Items>
        </Shared.Mobile>
        <Shared.Desktop>
          <Container>
            <Styled.Table>
              <Styled.TableHead>
                <TableRow>
                  <Styled.HeadCell>רכיב</Styled.HeadCell>
                  <Styled.HeadCell>תיאור תופעה</Styled.HeadCell>
                  <Styled.HeadCell>משך הארכת אחריות</Styled.HeadCell>
                </TableRow>
              </Styled.TableHead>
              <TableBody>
                {data.map((item, i) => (
                  <Styled.TableRow key={i}>
                    <Styled.Cell className="bold">{item.component}</Styled.Cell>
                    <Styled.Cell>{item.phenomenonDesc}</Styled.Cell>
                    <Styled.Cell>{item.extensionDuration}</Styled.Cell>
                  </Styled.TableRow>
                ))}
              </TableBody>
            </Styled.Table>
          </Container>
        </Shared.Desktop>
      </>
    )}
    {data.length === 0 && <EmptyResults />}
  </Styled.Wrapper>
)

export default WarrantyExtensionsTable
